import { Input } from "antd";
import React from "react";

const CustomInput = (props) => {
  return (
    <Input
      placeholder={props.placeholder}
      value={props.value}
      allowClear={props.clearable}
      name={props.name}
      onChange={(e) => props.changeHandler(e.target)}
      type={props.type ?? "text"}
      className={`customInput primary_input ${props.customClass}`}
      disabled={props.isDisable}
    />
  );
};

export default CustomInput;
